<template>
  <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Redirecionando para o sistema de pagamento...</h2>
                  <div v-if="finalUrl">
                    <p>Se não for redirecionado em 1 minuto, clique no link abaixo</p>
                    <a :href="finalUrl" style="color: white;">{{finalUrl}}</a>
                  </div>
                  <!--<b-button
                    variant="primary"
                    class="active mt-3"
                    to="/pages/register"
                  >Faça sua conta!</b-button>-->
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
</template>

<script>

export default {
  name: "PaymentLoad",
  data() {
    return {
      finalUrl: ""
    };
  },
  methods: {
    
  },
  created() {
    let existingTrackingData = undefined;

    if (localStorage.trackingData) {
      existingTrackingData = JSON.parse(localStorage.trackingData);
    }

    if (!existingTrackingData) {
      existingTrackingData = {};
    }

    
    existingTrackingData["visitedPagseguro"] = true;

    if (window.location.href.indexOf("pagae") >= 0) {
      existingTrackingData["visitedPagseguroPageAssinar"] = true;
    }
    

    localStorage.trackingData = JSON.stringify(existingTrackingData);

    gtag('event', 'conversion', {
        'send_to': 'AW-722097690/rKH7CLKO8OMBEJqsqdgC',
        'event_callback': () => {
          if (localStorage.paymentURL) {
            this.finalUrl = localStorage.paymentURL;
            localStorage.paymentURL = "";
          } else if (window.location.href.indexOf("pagae") >= 0){
            let pagae = window.location.href.split("pagae=")[1];
            this.finalUrl = "https://pag.ae/" + pagae;
          } else if (window.location.href.indexOf("fatura") >= 0){
            let pagae = window.location.href.split("fatura=")[1];
            this.finalUrl = "https://arsenaltecnologia.faturasimples.com.br/contratar/especiais?plano=" + pagae;
          } else if (window.location.href.indexOf("pagurl") >= 0){
            let pagurl = window.location.href.split("pagurl=")[1];
            this.finalUrl = decodeURIComponent(pagurl.replace(/\+/g, ' '));
          }

          if (this.finalUrl) {
            let special = false;
            for (let key in this.$route.query) {
              if (key == "open_parent") {
                special = true;
                window.parent.location.href = this.finalUrl;
              }
            }

            if (!special) {
              window.location.href = this.finalUrl;
            }
            
          } else {
            window.location.href = "/payments"
          }
          
        }
    });

    
  }
};
</script>